import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Subject } from 'rxjs';
import { ResponseModel } from '@shared/models/response.model';
import { OrderModel } from '@shared/models/order.model';
import { PaymentModel } from '@shared/models/payment.model';
import { getCurrentContextIds } from '@shared/utils/current-context.util';

@Injectable({ providedIn: 'root' })
export class OrderService {
  private update = new Subject<string>();
  constructor(private http: HttpClient) {}

  getAll(
    page = 0,
    perPage = 5,
    sort: string | null = null,
    filterKeyword: string | null = null,
    filterstatus: string,
    role: string | null = null
  ) {
    let params = new HttpParams().set('page', page).set('per_page', perPage);
    if (sort !== null) {
      params = params.set('sort', sort);
    }
    if (role !== null) {
      params = params.set('filter[role]', role);
    }
    if (filterKeyword !== null) {
      params = params.set('filter[search]', filterKeyword);
    }
    if (filterstatus !== null) {
      params = params.set('filter[status]', filterstatus);
    }
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.get<ResponseModel<OrderModel[]>>(`restaurants/${restaurantId}/branches/${branchId}/orders`, {
      params,
    });
  }

  getOrderByID(id: string) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.get<ResponseModel<OrderModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/orders/${id}`
    );
  }

  editOrder(id: string, order: object) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<OrderModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/orders/${id}?_method=PUT`,
      order
    );
  }

  deleteOder(id: string) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.delete(`restaurants/${restaurantId}/branches/${branchId}/orders/${id}`);
  }

  deleteSpecifiedOrderItem(orderId: string, orderItemId: string) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.delete(
      `restaurants/${restaurantId}/branches/${branchId}/orders/${orderId}/order-items/${orderItemId}`
    );
  }

  addOrder(order: object) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<OrderModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/orders/add-order`,
      order
    );
  }

  deleteManyItems(orderId: string, items: object) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<OrderModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/orders/${orderId}/order-items/delete-items`,
      items
    );
  }

  addItemToSpecificOrder(orderId: string, items: object) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.post<ResponseModel<OrderModel>>(
      `restaurants/${restaurantId}/branches/${branchId}/orders/${orderId}/order-items/add-order-item`,
      items
    );
  }

  getAllPayments(orderId: string) {
    const { restaurantId, branchId } = getCurrentContextIds();
    return this.http.get<ResponseModel<PaymentModel[]>>(
      `restaurants/${restaurantId}/branches/${branchId}/orders/${orderId}/show-order-payment`
    );
  }
  sendUpdate(message: string) {
    this.update.next(message);
  }

  getUpdate() {
    return this.update.asObservable();
  }
}
